import React from "react";
import PropTypes from "prop-types";
import { StyledIframe, VideoResponsive } from "../../components/Video/styled";

const VimeoEmbed = ({ embedId }) => (
  <VideoResponsive>
    <StyledIframe
      src={`https://player.vimeo.com/video/${embedId}?title=0&byline=0&portrait=0`}
      title="Vimeo video player"
      allow="autoplay; fullscreen; picture-in-picture"
      allowFullScreen
    />
  </VideoResponsive>
);

VimeoEmbed.propTypes = {
  embedId: PropTypes.string.isRequired
};

export default VimeoEmbed;